import { z } from "zod";

export const GameVersion = z.enum(["RED", "BLUE"]);
export type GameVersion = z.infer<typeof GameVersion>;

/** SHA-1 of the only ROMs RedChain accepts (§3.1). */
export const ROM_SHA1: Record<GameVersion, string> = {
  RED: "ea9bcae617fdf159b045185467ae58b2e4a48b9a",
  BLUE: "d7037c83e1ae5b39bde3c30787637ba1d4c48ce2",
};

export function versionForSha1(sha1: string): GameVersion | null {
  const s = sha1.toLowerCase();
  for (const v of GameVersion.options) if (ROM_SHA1[v] === s) return v;
  return null;
}

/** One emulated step in DMG T-cycles (§8.3). */
export const T_CYCLES_PER_STEP = 70224;
export const STEPS_PER_SECOND = 59.7275;
/** Minimum steps between two checkpoints for an auto-save (§7.4.1). */
export const AUTOSAVE_MIN_STEPS = 900n;
